import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  button: {
    alignSelf: 'flex-start',
  },
};

export default styles;
